import PropTypes from 'prop-types';
import cx from 'classnames';

import { UnorderedList } from './UnorderedList';
import styles from './UnorderedList.css';

const UnorderedListPlugin = ({
  className,
  UNORDERED_LIST_TAG,
  ...attributes
} = {}) => ({
  renderElement: UnorderedList({
    className: cx(styles.unorderedList, className),
    UNORDERED_LIST_TAG,
    ...attributes,
  }),
});

UnorderedListPlugin.propTypes = {
  className: PropTypes.string,
  UNORDERED_LIST_TAG: PropTypes.node,
};

export { UnorderedListPlugin };
